<template>
  <div class="subsector fossilbiomass">
    <div class="parent-sector">
      <p>Energy</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Combustion of Fossil and Biomass</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                CH₄ and N₂O emissions result from the combustion of fossil fuels
                and biomass in both stationary and mobile sources. CH₄ emissions
                are primarily a function of the CH₄ content of the fuel and the
                overall combustion efficiency. N₂O emissions vary according to
                the type of fuel, combustion technology, size and vintage,
                pollution control equipment used, and maintenance and operating
                practices.
              </p>
              <p>
                Between 1990 and 2015, CH₄ and N₂O emissions from fuel
                combustion increased by 36% as total fuel consumption increased
                by 53% on a BTU basis. Global trends in fuel consumption are
                largely related to historical trends in energy demand. Global
                demand for electricity has increased, which resulted in an
                increase in the use of fossil fuels and biomass for power
                generation. CH₄
                emissions are projected to continue to make up
                the largest portion of combustion emissions by gas, increasing
                from 62% of total combustion emissions in 1990 to 67% in 2030.
                Fossil fuels are also projected to continue to make up the
                majority of combustion emissions, increasing from 59% of total
                combustion emissions in 1990 to 72% in 2030.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartFossilBiomass1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <!--<button
              @click="
                switchComponent('ChartFossilBiomass2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>-->
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartFossilBiomass1 from "@/components/energy/ChartFossilBiomass1";
import ChartFossilBiomass2 from "@/components/energy/ChartFossilBiomass2";

export default {
  components: {
    ChartFossilBiomass1,
    ChartFossilBiomass2
  },
  data() {
    return {
      currentComp: "ChartFossilBiomass1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-blue-gold-nav.png") 0 -85px repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #6e5d11;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}
.center button {
  position: static !important;
}
</style>
